import Search from './Search'

export default [{
  path: '/follow/search/:search',
  name: 'FollowSearch',
  component: Search,
  meta: {auth: true, bodyClass: 'light-skin fixed-navbar sidebar-scroll fixed-footer', title: 'FollowSearch'}
}
]



// WEBPACK FOOTER //
// ./src/pages/follow/router.js